/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import intl from 'react-intl-universal';

import CasesManagerStatusContainer from 'src/ui/features/Cases/containers/CasesManagerStatusContainer';
import CasesConsentStatusContainer from 'src/ui/features/Cases/containers/CasesManagerConsentStatusContainer';
import CasesExpandButtonPres from './CasesExpandButtonPres';
// import CasesContactsContainer from 'src/ui/features/Cases/containers/CasesContactsContainer';
import CasesEmployeeContainer from 'src/ui/features/Cases/containers/CasesEmployeeContainer';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';

const CasesDetailsBarPres = props => {
  //const { onRefreshDetails, isEYPro, isCorpClient, caseClosed, headerDetails } = props;
  const { onRefreshDetails, isEYPro, isCorpClient, headerDetails } = props;

  const {
    caseId,
    profileKey,
    caseManagerId,
    clientName,
    applicant,
    // caseContacts,
    // caseEYContacts,
    // delegates,
    allowedAccess,
    caseStatusId,
    caseManagerCaseStatus,
    caseStatusText,
    reasonForStatusChange,
    currentEYStatus,
    currentSurePrepStatus,
    showCurrentEyStatus,
    primaryEYCaseContacts,
    secondaryEYCaseContacts,
    surePrepBinderId,
    // isPrimaryApplicant,
    caseClientName,
    caseConsentStatusId,
    caseConsentStatusText,
    consentStatus,
    countryAb,
    caseYear,
    allowedSpecialChars="\"/)”“‘’'(£!+$%-_.,;@?:*= &–€",
    allowedValidationSpecialChars= "+_-–=)(*&%$@!\"':;?/.,£’”“‘€"
  } = headerDetails;
  let additionalRestriction=["÷", "₹", "¥", "₩", "#","^","~","<",">","|","{","}","\\[","\\]"];
      additionalRestriction.filter((item,index)=> {let findList=allowedSpecialChars.indexOf(item)
        if(findList>-1){
          additionalRestriction.splice(index,1);
        }
      })

  if (!applicant) return false;

  return (
    <React.Fragment>
      <div className="cases-details-header">
        <Grid container className="header-grid" spacing={0}>
          <Grid item className={'header-field-item'}>
            <HistoryDisplayContainer history={props.history} />
          </Grid>
          {/* <Grid item xs={7} sm={7} md={7}></Grid> */}

          <Grid item className={'header-field-item'}>
            <div className="header-field nohover">
              <label className="field-label">Case ID</label>
              <span className="field-text">{caseId}</span>
            </div>
          </Grid>
          <Grid item className={'header-field-item'}>
            <div className="header-field nohover">
              <label className="field-label">Profile Key</label>
              <span className="field-text">{profileKey}</span>
            </div>
          </Grid>
          <Grid item>
            <div className={'employeeapplicant-wrapper'}>
              <CasesExpandButtonPres label={'Employee/Applicant'} value={`${applicant.firstName} ${applicant.lastName}`}>
                <CasesEmployeeContainer applicant={applicant} isCorpClient={isCorpClient} />
              </CasesExpandButtonPres>
            </div>
          </Grid>
          {isEYPro && (
            <Grid item className={'header-field-item'}>
              <div className="header-field nohover">
                <label className="field-label">Client</label>
                <span className="field-text">{clientName}</span>
              </div>
            </Grid>
          )}
          {showCurrentEyStatus && (
            <React.Fragment>
              <Grid item className={'header-field-item'}>
                <div className="header-field nohover">
                  <label className="field-label">{intl.get('cases.headers.sureprepbinderID')}</label>
                  <span className="field-text">{surePrepBinderId}</span>
                </div>
              </Grid>
              <Grid item className={'header-field-item'}>
                <div className="header-field nohover">
                  <label className="field-label">{intl.get('cases.headers.currenteystatus')}</label>
                  <span className="field-text">{currentEYStatus}</span>
                </div>
              </Grid>
              <Grid item className={'header-field-item'}>
                <div className="header-field nohover">
                  <label className="field-label">{intl.get('cases.headers.sureprepstatus')}</label>
                  <span className="field-text">{currentSurePrepStatus}</span>
                </div>
              </Grid>
            </React.Fragment>
          )}
          <Grid item className={'header-field-item'}>
            <div className="header-field nohover">
              <label className="field-label">Primary Case Contact</label>
              {primaryEYCaseContacts && primaryEYCaseContacts.firstName !== null && primaryEYCaseContacts.lastName !== null ? (
                <span className="field-text">{`${primaryEYCaseContacts && primaryEYCaseContacts.firstName} ${primaryEYCaseContacts &&
                  primaryEYCaseContacts.lastName}`}</span>
              ) : null}
            </div>
          </Grid>
          <Grid item className={'header-field-item'}>
            <div className="header-field nohover">
              <label className="field-label">Secondary Case Contact</label>
              {secondaryEYCaseContacts && secondaryEYCaseContacts.firstName !== null && secondaryEYCaseContacts.lastName !== null ? (
                <span className="field-text">{`${secondaryEYCaseContacts && secondaryEYCaseContacts.firstName} ${secondaryEYCaseContacts &&
                  secondaryEYCaseContacts.lastName}`}</span>
              ) : (
                <span className="field-text"></span>
              )}
            </div>
          </Grid>
          <Grid item className={'header-field-item'}>
            <div className="header-field nohover">
              <label className="field-label">{intl.get('cases.details.clientName')}</label>
              <span className="field-text">{caseClientName}</span>
            </div>
          </Grid>
          <Grid item className="caseHoldStatus">
            <CasesExpandButtonPres
              dynamicOrient={true}
              label={intl.get('cases.status.caseStatus')}
              orientation={'left'}
              value={caseStatusText}>
              <CasesManagerStatusContainer
                caseManagerId={caseManagerId}
                caseStatusId={caseStatusId}
                reasonForStatusChange={reasonForStatusChange}
                statusList={caseManagerCaseStatus}
                onRefreshDetails={onRefreshDetails}
                allowedSpecialChars={allowedSpecialChars}
                additionalCharRestict={additionalRestriction}
                allowedValidationSpecialChars={allowedValidationSpecialChars}
              />
            </CasesExpandButtonPres>
          </Grid>
          {allowedAccess === 'No' && countryAb === 'US' && caseYear >= 2023 && (
            <Grid item className="caseHoldStatus">
              <CasesExpandButtonPres
                dynamicOrient={true}
                label={intl.get('cases.status.consentStatus')}
                orientation={'left'}
                value={caseConsentStatusText}>
                <CasesConsentStatusContainer
                  caseManagerId={caseManagerId}
                  consentStatusId={caseConsentStatusId}
                  statusList={consentStatus}
                  onRefreshDetails={onRefreshDetails}
                />
              </CasesExpandButtonPres>
            </Grid>
          )}
          {/* <Grid item xs={1} className={'clientid-width-wrapper'}>
            <div className="header-field nohover">
              <label className="field-label">Case ID</label>
              <span className="field-text">{caseId}</span>
            </div>
          </Grid>
          <Grid item xs={1} className={'profileid-width-wrapper'}>
            <div className="header-field nohover">
              <label className="field-label">Profile Key</label>
              <span className="field-text">{profileKey}</span>
            </div>
          </Grid>
          <Grid item xs={2}>
            <div className={'employeeapplicant-wrapper'}>
              {applicant && (
                <CasesExpandButtonPres label={'Employee/Applicant'} value={`${applicant.firstName} ${applicant.lastName}`}>
                  <CasesEmployeeContainer applicant={applicant} isCorpClient={isCorpClient} />
                </CasesExpandButtonPres>
              )}
            </div>
          </Grid>
          {isEYPro && (
            <Grid item xs={2} className={'clientname-width-wrapper'}>
              <div className="header-field nohover">
                <label className="field-label">Client</label>
                <span className="field-text">{clientName}</span>
              </div>
            </Grid>
          )}
          <Grid item xs={7} sm={7} md={7}>
            {showCurrentEyStatus && (
              <React.Fragment>
                <div className="eystatus-header-detail">
                  <p className="status-header-label">{intl.get('cases.headers.currenteystatus')}</p>
                  <p className="status-header-current">{currentEYStatus}</p>
                </div>
                <div className="eystatus-header-detail">
                  <p className="status-header-label">{intl.get('cases.headers.sureprepstatus')}</p>
                  <p className="status-header-current">{currentSurePrepStatus}</p>
                </div>
                <div className="eystatus-header-detail">
                  <p className="status-header-label">{intl.get('cases.headers.sureprepbinderID')}</p>
                  <p className="status-header-current">{surePrepBinderId}</p>
                </div>
              </React.Fragment>
            )}
          </Grid>
          
          <Grid item xs={1} className={'profileid-width-wrapper'}>
            <div className="header-field nohover">
              <label className="field-label">Primary Case</label>
              <span className="field-text">{isPrimaryApplicant}</span>
            </div>
          </Grid>
          
          <Grid item xs={2}>
            <CasesExpandButtonPres
              label={'Case Contacts/Delegate'}
              value={`${primaryEYCaseContacts.firstName} ${primaryEYCaseContacts.lastName}`}>
              <CasesContactsContainer
                caseManagerId={caseManagerId}
                caseEYContacts={caseEYContacts}
                primaryEYCaseContacts={primaryEYCaseContacts}
                secondaryEYCaseContacts={secondaryEYCaseContacts}
                caseContacts={caseContacts}
                onRefreshDetails={onRefreshDetails}
                isEYPro={isEYPro}
                delegates={delegates}
                caseClosed={caseClosed}
              />
            </CasesExpandButtonPres>
          </Grid>
          <Grid item xs={2} className="caseHoldStatus">
            {caseStatusText && (
              <CasesExpandButtonPres label={intl.get('cases.status.caseStatus')} orientation={'right'} value={caseStatusText}>
                <CasesManagerStatusContainer
                  caseManagerId={caseManagerId}
                  caseStatusId={caseStatusId}
                  reasonForStatusChange={reasonForStatusChange}
                  statusList={caseManagerCaseStatus}
                  onRefreshDetails={onRefreshDetails}
                />
              </CasesExpandButtonPres>
            )}
          </Grid> */}
        </Grid>
      </div>
    </React.Fragment>
  );
};

CasesDetailsBarPres.prototype = {
  onRefreshDetails: PropTypes.func.isRequired,
  //frequencyList: PropTypes.any.isRequired,
  caseManagerId: PropTypes.any,
  chaseFrequencyId: PropTypes.any,
  isEYPro: PropTypes.any,
  isCorpClient: PropTypes.any,
  caseClosed: PropTypes.any,
  history: PropTypes.any,
};

export default CasesDetailsBarPres;
